import React from "react";
import { ModalShell } from "./ui-helpers";

export function ExpandableChart({
  title = "Chart",
  subtitle = "",
  renderChart,
  footer = null,
  className = "",
  expandLabel = "Expand chart",
}) {
  const [open, setOpen] = React.useState(false);
  const renderFooter = (expanded) => (typeof footer === "function" ? footer({ expanded }) : footer);

  return (
    <div className={`expandable-chart ${className}`.trim()}>
      <div className="expandable-chart-body">
        {renderChart ? renderChart({ expanded: false }) : null}
      </div>
      {renderFooter(false) ? <div className="expandable-chart-footer">{renderFooter(false)}</div> : null}
      <button className="chart-expand-button" type="button" onClick={() => setOpen(true)} aria-label={expandLabel} title={expandLabel}>
        <span aria-hidden="true">⤢</span>
      </button>
      <ModalShell
        open={open}
        title={title}
        subtitle={subtitle}
        size="xl"
        className="chart-expanded-modal"
        onClose={() => setOpen(false)}
      >
        <div className="expanded-chart-body">
          {renderChart ? renderChart({ expanded: true }) : null}
        </div>
        {renderFooter(true) ? <div className="expanded-chart-footer">{renderFooter(true)}</div> : null}
      </ModalShell>
    </div>
  );
}

export function DetailsModal({
  title = "Details",
  columns = [],
  rows = [],
  emptyText = "No details available.",
  triggerLabel = "ⓘ Details",
  triggerClassName = "btn btn-secondary",
}) {
  const [open, setOpen] = React.useState(false);
  const safeColumns = Array.isArray(columns) ? columns : [];
  const safeRows = Array.isArray(rows) ? rows : [];

  return (
    <>
      <button className={triggerClassName} type="button" onClick={() => setOpen(true)}>
        {triggerLabel}
      </button>
      <ModalShell open={open} title={title} size="lg" className="chart-details-modal" onClose={() => setOpen(false)}>
        {safeRows.length ? (
          <div className="table--card chart-details-table-wrap">
            <div className="table-scroll">
              <table className="table table--dense chart-details-table">
                <thead>
                  <tr>
                    {safeColumns.map((column) => <th key={column.key}>{column.label || column.key}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {safeRows.map((row, idx) => (
                    <tr key={row.id || idx}>
                      {safeColumns.map((column) => (
                        <td key={column.key}>{column.render ? column.render(row) : (row[column.key] ?? "—")}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="empty-state">{emptyText}</div>
        )}
      </ModalShell>
    </>
  );
}
